import { useEffect, useState } from 'react';
import { ProductCarousel } from '@/components/home/ProductCarousel';
import { categoryCarousels } from '@/data/homeContent';
import { MOCK_PRODUCTOS } from '@/data/mockCatalog';
import { api } from '@/lib/api';
import { cn } from '@/lib/utils';
import type { Producto } from '@/types';

const POR_CATEGORIA = 10;

type CategoriaProductos = {
  slug: string;
  title: string;
  subtitle?: string;
  productos: Producto[];
};

function mockPorCategoria(slug: string): Producto[] {
  return MOCK_PRODUCTOS.filter((p) => p.categoria === slug).slice(0, POR_CATEGORIA);
}

export function CategoryProductCarousels() {
  const [bloques, setBloques] = useState<CategoriaProductos[]>([]);
  const [cargando, setCargando] = useState(true);

  useEffect(() => {
    Promise.all(
      categoryCarousels.map(async (cat) => {
        try {
          const res = await api.productos({
            categoria: cat.slug,
            page: 1,
            limit: POR_CATEGORIA,
          });
          const items = res.items?.length ? res.items.slice(0, POR_CATEGORIA) : mockPorCategoria(cat.slug);
          return { ...cat, productos: items };
        } catch {
          return { ...cat, productos: mockPorCategoria(cat.slug) };
        }
      }),
    ).then((resultados) => {
      setBloques(resultados.filter((b) => b.productos.length > 0));
      setCargando(false);
    });
  }, []);

  if (cargando) {
    return (
      <div className="space-y-4 py-8">
        {[1, 2].map((n) => (
          <div key={n} className="container-app">
            <div className="mb-4 h-6 w-48 animate-pulse rounded bg-surface-200" />
            <div className="flex gap-4 overflow-hidden">
              {[1, 2, 3, 4].map((c) => (
                <div key={c} className="h-72 w-[260px] shrink-0 animate-pulse rounded-lg bg-surface-100" />
              ))}
            </div>
          </div>
        ))}
      </div>
    );
  }

  if (bloques.length === 0) return null;

  return (
    <>
      {bloques.map((bloque, i) => (
        <ProductCarousel
          key={bloque.slug}
          title={bloque.title}
          subtitle={bloque.subtitle}
          products={bloque.productos}
          viewAllHref={`/catalogo?categoria=${bloque.slug}`}
          viewAllLabel={`Ver ${bloque.title.toLowerCase()}`}
          className={cn(i > 0 && 'border-t border-surface-200', i % 2 === 1 && 'bg-surface-50')}
        />
      ))}
    </>
  );
}
